<template>
  <div class="tracking-d-index">
    <div class="t-d-i-header">
      <wb-header></wb-header>
      <div class="tdi-h-content">
        <p class="tdi-h-c-title">Precision Genomics Cloud</p>
        <p class="tdi-h-c-doc">
          实现项目组内医院数据的分析、共享和整合 为全球研究界提供数据和分析资源
        </p>
        <div class="tdi-h-c-border">
          <div class="tdi-h-c-left">
            <p class="tdi-h-c-text">实验样本</p>
            <p class="tdi-h-c-num">{{ statData.sampleNum || '****' }}</p>
          </div>
          <div class="tdi-h-c-right">
            <p class="tdi-h-c-text">合作医院</p>
            <p class="tdi-h-c-num">{{ statData.hospitalNum || '***' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="t-d-i-content">
      <div class="tdi-c-title">应用服务</div>
      <a-row type="flex" justify="space-between">
        <a-col :span="6" class="tdi-c-space-hover">
          <div class="tdi-s-spacel">
            <div class="tdi-c-space" @click="goToPage('blood')">
              <h2 class="tdi-c-space-title">Precision Diagnosis</h2>
              <div class="tdi-c-space-image tdi-c-space-image01"></div>
              <p>组内医院患者信息互联互通</p>
              <p>多中心数据统一管控</p>
              <p>分析流程自动化与标准化</p>
              <div class="tdi-c-space-bottom">
                点击进入
                <span>>></span>
              </div>
            </div>
            <!-- <div class="tdi-c-space-to">
              <div class="tdi-c-space-to-blood" @click="goToPage('blood')">
                CCCG-ALL
                <span>>></span>
              </div>
              <div class="tdi-c-space-to-tumour" @click="goToPage('tumour')">
                SCMC-ST
                <span>>></span>
              </div>
            </div> -->
          </div>
          <div class="tdi-c-space-border"></div>
        </a-col>
        <a-col :span="6" class="tdi-c-space-hover">
          <div class="tdi-c-space" @click="goToPage('database')">
            <h2 class="tdi-c-space-title">Genomics Database</h2>
            <div class="tdi-c-space-image tdi-c-space-image02">
              <svg t="1631687681643" class="icon" viewBox="0 0 1152 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="2364" width="46" height="46">
                <path
                  d="M593.1264 531.072c48.256 52.8896 94.976 105.8048 143.232 155.4944 17.8944-8.832 35.7888-17.6384 54.4768-25.6512-59.136-46.4896-113.664-100.992-168.9088-156.288-10.112 8.8064-19.456 17.6384-28.8 26.4448z m-78.6176 77.7472C360.3968 763.52 214.8352 911.7952 0 911.7952V1024c305.1264 0 447.5648-158.72 642.944-283.7248-42.0352-44.0832-84.0704-88.9856-128.4352-131.456z m439.7824 0.7936c59.136-12.032 123.7504-18.432 197.7088-18.432V262.5536c-182.144 0-320.6912 69.7344-439.808 163.5072 76.288 74.5472 154.1376 141.8752 242.0992 183.552zM0 647.296v136.2432c217.1648 0 351.8208-96.1792 481.024-205.9776-36.5824-32.8704-74.7008-63.3344-115.968-89.7792-105.856 91.392-219.4944 159.488-365.056 159.488z m567.4496-144.2816c9.3184-8.0128 18.688-16.0256 28.8-24.064-35.84-35.2512-73.1904-71.3216-112.1024-104.192-7.7824 7.2192-15.5648 15.2576-22.5792 22.4512 36.608 33.664 71.6288 69.7344 105.8816 105.8048z"
                  fill="#5A9040" p-id="2365" />
                <path
                  d="M576 279.3216c40.192 37.9136 79.616 77.3888 118.272 114.5344 116.7616-78.1568 255.9232-138.496 457.728-138.496V0c-255.9232 0-424.448 134.656-576 279.3216z"
                  fill="#5A9040" p-id="2366" />
                <path
                  d="M0 0v177.92c217.1648 0 361.9584 79.2576 484.1472 179.4816 28.8-27.9552 58.368-56.704 87.9616-84.6848C421.0944 130.56 252.9792 0 0 0z m1152 761.4464v-132.096c-72.3968 0-137.7792-16.3072-197.7088-44.288a867.2 867.2 0 0 0-164.2496 48.9472c98.0992 74.5984 210.176 127.4368 361.9584 127.4368z"
                  fill="#405D90" p-id="2367" />
                <path
                  d="M623.7184 495.36c55.3984 54.4512 110.0288 108.0832 169.3184 153.8304a844.3392 844.3392 0 0 1 164.6336-49.6896c-88.1664-41.0368-166.1952-107.264-243.456-180.6336a1607.5776 1607.5776 0 0 0-90.496 76.4928z m70.2208-97.024c-39.7824-38.656-78.7968-78.08-119.3728-116.736-29.6448 28.416-59.2896 57.6-88.1664 85.9904 39.0144 32.3328 76.4672 67.84 112.3584 102.528 30.4384-24.448 61.6448-48.896 95.1808-71.7824zM1152 1024v-110.6432c-168.1408 0-294.2208-98.7648-415.6416-222.848a1219.1488 1219.1488 0 0 0-94.208 53.76C781.4912 888.832 919.296 1024 1152 1024zM0 210.048v180.992c151.0144 0 267.008 41.856 365.056 103.5008 32.6912-27.648 64.6144-57.7024 96.512-88.4992C337.0496 295.3984 193.024 210.048 0 210.048z"
                  fill="#405D90" p-id="2368" />
                <path
                  d="M514.0736 604.3904c43.8016 42.2656 85.2992 86.9376 126.0288 130.7904a965.4784 965.4784 0 0 1 92.9792-54.2208c-46.848-49.4592-92.9792-102.0928-141.3888-154.7264l-77.6192 78.1568z m-52.224-210.5344c-31.5136 31.104-63.0272 61.3888-95.3088 89.3184 41.4976 26.3168 79.1552 56.6272 114.5088 89.3184 28.416-23.936 56.8576-49.4592 85.2992-74.1632-33.8176-35.0976-68.4032-70.9888-104.5248-104.4736z"
                  fill="#405D90" p-id="2369" />
              </svg>
            </div>
            <p>数据交互可视化</p>
            <p>操作模式多样化</p>
            <p>用以探究儿童癌症的研究</p>
            <div class="tdi-c-space-bottom">
              点击进入
              <span>>></span>
            </div>
          </div>
          <div class="tdi-c-space-border"></div>
        </a-col>
        <a-col :span="6" class="tdi-c-space-hover">
          <div class="tdi-c-space" @click="goToPage('datasharing')">
            <h2 class="tdi-c-space-title">Genomics Datasharing</h2>
            <div class="tdi-c-space-image tdi-c-space-image03">
              <svg t="1631688067447" class="icon" viewBox="0 0 1536 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="2953" width="46" height="46">
                <path
                  d="M1238.4 386.56C1194.88 165.76 1000.96 0 768 0c-184.96 0-345.6 104.96-425.6 258.56C149.76 279.04 0 442.24 0 640c0 211.84 172.16 384 384 384h832C1392.64 1024 1536 880.64 1536 704c0-168.96-131.2-305.92-297.6-317.44zM896 576v256H640v-256h-192L768 256l320 320H896z"
                  fill="#0C5198" p-id="2954" />
              </svg>
            </div>
            <p>独有的数据特征动态跟踪技术</p>
            <p>结合标签形式的样本信息管理</p>
            <p>实现基因数据的快速检索和数据挖掘</p>
            <div class="tdi-c-space-bottom">
              点击进入
              <span>>></span>
            </div>
          </div>
          <div class="tdi-c-space-border"></div>
        </a-col>
        <a-col :span="6" class="tdi-c-space1-hover">
          <div class="tdi-s-spacel-one">
            <div class="tdi-c-space">
              <h2 class="tdi-c-space-title">Ronglian BioCloud</h2>
              <div class="tdi-c-space-image tdi-c-space-image04">
                <svg t="1631688028590" class="icon" viewBox="0 0 1177 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="2810" width="46" height="46">
                  <path
                    d="M1051.0336 998.7328h108.3904V22.9376H725.7088v3.1232c179.6608 0 325.3248 145.664 325.3248 325.2736 0 179.6352-145.664 325.2992-325.3248 325.2992 179.6608 0 325.3248 145.6128 325.3248 325.2224"
                    fill="#DC772D" p-id="2811" />
                  <path
                    d="M603.3152 22.8864c-191.6672 0-346.9824 155.4176-346.9824 347.0336l-57.7536 6.4C94.08 431.9488 22.912 542.0032 22.912 668.672c0 182.8864 148.224 331.0848 331.136 331.0848h249.2672"
                    fill="#2C569C" p-id="2812" />
                </svg>
              </div>
              <p>内置交互多款交互分析小工具和流程</p>
              <p>个性化数据挖掘更敏捷</p>
              <p>可直接保存图片，用于论文发表</p>
              <div class="tdi-c-space-bottom">
                点击进入
                <span>>></span>
              </div>
            </div>
            <div class="tdi-c-space-to">
              <div class="tdi-c-space-to-blood" @click="goToPage('biocloud')">
                RongLian BioCloud
                <span>>></span>
              </div>
              <div class="tdi-c-space-to-tumour" @click="goToPage('BALL6')">
                BALL6
                <span>>></span>
              </div>
            </div>
          </div>
          <div class="tdi-c-space-border"></div>
        </a-col>
      </a-row>
    </div>
    <wb-footer></wb-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import WbHeader from "../../components/wordbench/header.vue";
import WbFooter from "../../components/wordbench/footer.vue";

export default {
  computed: {
    ...mapState({
      user: (state) => state.account.user,
      token: (state) => state.account.token,
      avatar() {
        return `static/avatar/${this.user.avatar}`;
      },
    }),
  },
  components: {
    WbHeader,
    WbFooter,
  },
  data() {
    return {
      statData: {},
      test: "",
    };
  },
  mounted() {
    if (this.token && this.user.nickName) {
      this.getStatData();
    }
  },
  methods: {
    getStatData() {
      this.$get("/mt/stat").then((res) => {
        if (res.data.code == 1) {
          this.statData = res.data.data;
        }
      });
    },
    goToPage(type) {
      switch (type) {
        case "login":
          this.$router.push("/login");
          break;
        case "register":
          this.$router.push("/register");
          break;
        case "blood":
          this.$router.push("/home");
          break;
        case "tumour":
          // this.$router.push("/");
          this.$message.warning("正在努力的开发中，请耐心等待！");
          break;
        case "database":
          this.$router.push("/molecular");
          break;
        case "datasharing":
          // this.$router.push("/");
          this.$message.warning("正在努力的开发中，请耐心等待！");
          break;
        case "workbench":
          this.$message.warning("正在努力的开发中，请耐心等待！");
          break;
        case "BALL6":
          this.$router.push("/analysis");
          break;
        case "biocloud":
          window.open("http://biocloud.ronglian.com/");
          break;
        case "ronglian":
          window.open("http://www.ronglian.com/");
          break;
      }
    },
    logout() {
      NProgress.start();
      this.$get(`logout/${this.user.id}`).then(
        () => {
          return new Promise((resolve, reject) => {
            NProgress.done();
            this.$db.clear();
            location.reload();
          });
        },
        () => {
          NProgress.done();
          this.$message.error("退出系统失败");
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.tdi-link {
  cursor: pointer;
}

.t-d-i-header {
  height: 350px;
  background: url("../../assets/image/homeImg/background_cccgall_cloud.png") no-repeat center;
  background-size: cover;
  background-position-y: inherit;

  .ant-dropdown-link {
    color: #fff;
  }

  .left {
    float: left;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    line-height: 52px;
  }

  .right {
    float: right;
    text-align: right;
    line-height: 52px;
  }

  .tdi-h-bell {
    width: 28px;
    height: 30px;
    display: inline-block;
    padding: 4px 10px;
    background: url("../../assets/image/homeImg/log_icon.png") no-repeat;
    background-position: bottom;
    position: relative;
    top: 6px;
    cursor: pointer;
    margin-right: 10px;
  }

  .tdi-h-to {
    font-size: 14px;
    color: #ffffff;
    padding: 4px 20px;
    margin: 0 5px;
    cursor: pointer;
  }

  .tdi-h-to:hover {
    background-color: #4c83ff;
  }

  .tdi-h-content {
    width: 360px;
    margin: 0 auto;
    padding-top: 30px;

    p {
      margin: 0 0;
      color: #ffffff;
    }

    .tdi-h-c-title {
      font-size: 36px;
      font-weight: 600;
      text-align: center;
      line-height: 50px;
      letter-spacing: 1px;
    }

    .tdi-h-c-doc {
      font-size: 18px;
      line-height: 25px;
      text-align: center;
    }

    .tdi-h-c-border {
      border-top: 1px solid #979797;
      padding-top: 15px;
      margin-top: 24px;
    }

    .tdi-h-c-left,
    .tdi-h-c-right {
      float: left;
      width: 180px;
      text-align: center;
    }

    .tdi-h-c-left {
      border-right: 1px solid #979797;
      padding-left: 34px;
    }

    .tdi-h-c-right {
      padding-right: 34px;
    }

    .tdi-h-c-text {
      font-size: 18px;
      line-height: 25px;
    }

    .tdi-h-c-num {
      font-size: 36px;
      color: #4c83ff;
      line-height: 50px;
      text-align: center;
    }
  }
}

.t-d-i-content {
  padding: 16px 112px;
  background-color: #d8d8d8;

  .tdi-c-title {
    font-size: 18px;
    color: #405d90;
    font-weight: 600;
    line-height: 25px;
    text-indent: 40px;
    padding-bottom: 12px;
  }

  .tdi-c-space-border {
    margin: 12px 8px;
    height: 1px;
    background-color: #ffffff;
  }

  .tdi-s-spacel-one {
    position: relative;
    height: 317px;
    background-color: #fff;
    margin: 0px 8px;
    overflow: hidden;

    .tdi-c-space {
      position: absolute;
      z-index: 1;
      height: 317px;
      opacity: 1;
      left: 0;
      top: 0;
      -moz-transition: all 0.2s ease-in;
      -webkit-transition: all 0.2s ease-in;
      -o-transition: all 0.2s ease-in;
      transition: all 0.2s ease-in;
    }

    .tdi-c-space-to {
      position: absolute;
      z-index: 2;
      opacity: 0;
      right: 160px;
      top: 0;
      height: 317px;
      width: 100%;
      border: 1px solid #4c83ff;
      background-color: #fff;
      cursor: pointer;
      -moz-transition: all 0.2s ease-in;
      -webkit-transition: all 0.2s ease-in;
      -o-transition: all 0.2s ease-in;
      transition: all 0.2s ease-in;

      .tdi-c-space-to-tumour,
      .tdi-c-space-to-blood {
        margin-left: -1px;
        height: 158px;
        font-size: 21px;
        color: #162232;
        line-height: 158px;
        text-align: center;

        span {
          font-family: "宋体";
          font-size: 22px;
          margin-left: 5px;
        }
      }

      .tdi-c-space-to-tumour:hover,
      .tdi-c-space-to-blood:hover {
        background-color: #4c83ff;
        color: #fff;
      }
    }
  }

  .tdi-c-space {
    position: relative;
    height: 317px;
    background-color: #fff;
    padding: 24px 24px;
    margin: 0 8px;
    -moz-transition: all 0.2s ease-in;
    -webkit-transition: all 0.2s ease-in;
    -o-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;

    p {
      margin: 0 0;
      padding-bottom: 10px;
      font-size: 12px;
      color: #646464;
      line-height: 17px;
    }
  }

  .tdi-c-space-title {
    height: 25px;
    font-size: 18px;
    font-weight: 600;
    color: #405d90;
    line-height: 25px;
  }

  .tdi-c-space-image {
    width: 100%;
    height: 43px;
    margin: 35px 0;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;
  }

  .tdi-c-space-image01 {
    background-image: url("../../assets/image/homeImg/tracking_logo.png");
  }

  .tdi-c-space-image02 {
    // background-image: url("../../assets/image/homeImg/slices_icon.png");
  }

  .tdi-c-space-image03 {
    // background-image: url("../../assets/image/homeImg/shape_icon.png");
  }

  .tdi-c-space-image04 {
    // background-image: url("../../assets/image/homeImg/group_icon.png");
  }

  .tdi-c-space-bottom {
    cursor: pointer;
    position: absolute;
    bottom: 24px;
    left: 33px;
    font-size: 12px;
    color: #4c83ff;
    line-height: 17px;

    span {
      font-size: 13px;
      font-family: "宋体";
      margin-left: 5px;
    }
  }

  .tdi-c-space1-hover:hover {
    .tdi-c-space {
      left: -160px;
      opacity: 0;
    }

    .tdi-c-space-to {
      right: 0;
      opacity: 1;
    }

    .tdi-c-space-border {
      background-color: #4c83ff;
    }
  }

  .tdi-c-space-hover:hover {
    cursor: pointer;

    .tdi-c-space {
      background-color: #4c83ff;
    }

    .tdi-c-space-border {
      background-color: #4c83ff;
    }

    p,
    .tdi-c-space-title,
    .tdi-c-space-bottom {
      color: #fff;
    }
  }
}

.t-d-i-footer-top {
  .iconfont {
    margin-right: 15px;
  }

  .ftop-font16 {
    font-size: 16px;
    font-weight: 600;
  }

  .ftop-font14 {
    font-size: 14px;
    font-weight: 600;
  }

  background-color: #13223d;
  font-size: 12px;
  color: #b5b5b5;
  line-height: 32px;
  padding: 22px 120px;
}

.t-d-i-footer-bottom {
  height: 35px;
  font-size: 12px;
  color: #b5b5b5;
  line-height: 35px;
  text-align: center;
  background-color: #000;
}
</style>